import { createWidget } from '@funtech-int/rival';

export const redAlertBarWidget = createWidget<unknown, {}>();
